import React from 'react';
import './MarriottDigitalHero.css'; // Reusing the same CSS for the layout
import OptimizedImage from './OptimizedImage';

import largeHeroAvif from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero.avif';
import largeHeroWebp from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero.webp';
import largeHero from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero.jpg';
import largeHeroMobileAvif from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero_mobile.avif';
import largeHeroMobileWebp from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero_mobile.webp';
import largeHeroMobile from 'url:../../assets-optimized/redesign/solutions/offsite_digital_hero_mobile.jpg';

const OffsiteDigitalHero = () => {
  return (
    <section className='marriott-digital-hero'>
      <div className='md-hero-left'>
        <OptimizedImage
          avif={largeHeroAvif}
          webp={largeHeroWebp}
          fallback={largeHero}
          mobileAvif={largeHeroMobileAvif}
          mobileWebp={largeHeroMobileWebp}
          mobileFallback={largeHeroMobile}
          alt='Traveler using a phone at an EV charging station'
          className='md-hero-image'
        />
        <div className='md-hero-left-overlay'>
          <h2 className='md-hero-pill no-wrap'>Offsite Digital</h2>
        </div>
      </div>
      <div className='md-hero-right'>
        <h1 className='md-hero-right-title'>
          TRAVELER <br className='desktop-only' />
          DATA
        </h1>
        <p className='md-hero-right-statement'>
          <span className='md-hero-bullet' aria-hidden='true' />
          EXTEND THE JOURNEY BEYOND OUR WALLS
        </p>
      </div>
    </section>
  );
};

export default OffsiteDigitalHero;
